import React from "react";
import styles from "./DataBy.module.css";
import dataByImg from "../../../assets/images/common/MotorsportData.png";

const DataBy = (props) => {
  return (
    <a target={"_blank"} href={"https://results.motorsportstats.com"} className={styles.dataFromLabel}>
      <p>DATA</p>
      <img className={styles.dataFromIcon} src={dataByImg} alt={"MOTORSPORT STATS"} />
    </a>
  );
};

export default DataBy;
